import React from 'react'
import './Home.css'

function Home() {
    return (
        <div class='homebubble__container'>
            <div class = 'homebubble__container2'>
                <div class='homebubble'>
                    <h1>Welcome!</h1>  
                    <p>I'm Tess and I am a third year computer science student at McGill University! 
                        This website was my first personal project and I will continue to improve and update it as I learn more!</p>          
                </div>
             </div>
        </div>
    );
};

export default Home